export default __webpack_public_path__ + "static/media/BSCImg.691d3278.png";